var React = require('react');

function Android (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m111.767 272.054 4.977-8.622a1.011 1.011 0 0 0 -.366-1.378 1 1 0 0 0 -1.372.366l-5.042 8.733a31.464 31.464 0 0 0 -25.669 0l-5.042-8.733a1.008 1.008 0 1 0 -1.744 1.012l4.977 8.622a29.717 29.717 0 0 0 -15.356 23.508h60a29.708 29.708 0 0 0 -15.363-23.508zm-28.413 15.082a2.515 2.515 0 1 1 2.515-2.515 2.516 2.516 0 0 1 -2.515 2.515zm27.544 0a2.515 2.515 0 1 1 2.515-2.515 2.516 2.516 0 0 1 -2.513 2.515z","fill":"#d8d8d8","transform":"translate(-67.13 -261.917)"}));
}

Android.defaultProps = {"height":"33.645","viewBox":"0 0 60 33.645","width":"60"};

module.exports = Android;

Android.default = Android;
